import React, { useRef } from 'react';

import ModalDirectors from './ModalDirectors';

import CarlosBg from '../../../../../Images/modals/directors/carlos/bg_carlos.png';
import Video1 from '../../../../../Images/modals/directors/carlos/video-1.png';
import Video2 from '../../../../../Images/modals/directors/carlos/video-2.png';
import Video3 from '../../../../../Images/modals/directors/carlos/video-3.png';
import Video4 from '../../../../../Images/modals/directors/carlos/video-4.png';

import {
  Director_Carlos,
  Text_Carlos,
  TextVideo1_Carlos,
  TextVideo2_Carlos,
  TextVideo3_Carlos,
  TextVideo4_Carlos,
} from '../../../../../utils/EN/Modals/directors';

const ModalCarlos = () => {
  return (
    <>
      <ModalDirectors
        id="director-carlos"
        mainBg={CarlosBg}
        directorName={Director_Carlos}
        mainVideoBg={Video1}
        videoText1={TextVideo1_Carlos}
        directorText={Text_Carlos}
        rowImage1={Video2}
        videoText2={TextVideo2_Carlos}
        rowImage2={Video3}
        videoText3={TextVideo3_Carlos}
        rowImage3={Video4}
        videoText4={TextVideo4_Carlos}
        mainVideoLink={'carlos-video-1'}
        rowVideoLink1={'carlos-video-2'}
        rowVideoLink2={'carlos-video-3'}
        rowVideoLink3={'carlos-video-4'}
      />
    </>
  );
};

export default ModalCarlos;
